<template>
    <div>
        <div class="row">

            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-6 col-md-6 mb-3">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="font-weight-bold text-primary text-uppercase mb-1">Invited</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ event.guests_count }}</div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-users fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-6 col-md-6 mb-3">
                <div class="card border-left-info shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="font-weight-bold text-info text-uppercase mb-1">Referred</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ event.referred_guests_count }}</div>
                                <!--<div class="row no-gutters align-items-center">
                                    <div class="col-auto">
                                        <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">{{ event.referred_guests_count }}</div>
                                    </div>
                                    <div class="col">
                                        <div class="progress progress-sm mr-2">
                                            <div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-user-plus fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-4 col-md-6 mb-3">
                <div class="card border-left-success shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="font-weight-bold text-success text-uppercase mb-1">Accepted</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ event.accepted_guests_count }}</div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-calendar-check fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-4 col-md-6 mb-3">
                <div class="card border-left-warning shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="font-weight-bold text-warning text-uppercase mb-1">Not Interested</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ event.rejected_guests_count }}</div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-calendar-times fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Pending Requests Card Example -->
            <div class="col-xl-4 col-md-6 mb-3">
                <div class="card border-left-danger shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="font-weight-bold text-danger text-uppercase mb-1">Attended</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ attended_count }}</div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-user-check fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <h5>Contact List</h5>
                <p>{{ event.contact_list.name }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col">

                <vue-bootstrap4-table :rows="event.guests" :columns="dt.columns" :config="dt.config" :classes="dt.classes"
                                      :actions="dt.actions" @on-download="download">
                    <template slot="sort-asc-icon">
                        <i class="fas fa-sort-up"></i>
                    </template>
                    <template slot="sort-desc-icon">
                        <i class="fas fa-sort-down"></i>
                    </template>
                    <template slot="no-sort-icon">
                        <i class="fas fa-sort text-gray-200"></i>
                    </template>
                    <template slot="tel" slot-scope="props">
                        <span v-if="props.row.areacode" class="">({{ props.row.areacode }}) {{ props.row.tel }}</span>
                        <span v-else>{{ props.row.tel }}</span>
                    </template>
                    <template slot="referrer" slot-scope="props">
                        <span v-if="props.row.referrer" class="">{{ props.row.referrer.name }} ({{ props.row.referrer.company }})</span>
                        <span v-else></span>
                    </template>
                    <template slot="accepted" slot-scope="props">
                        <span v-if="props.row.accepted_at" >
                            <button class="btn btn-success btn-circle btn-sm" @click.prevent="unaccept(props.row.hashid)">
                                <i class="fas fa-check"></i>
                            </button>
                            <button v-if="!event.ended" class="btn btn-success btn-icon-split btn-sm" title="Re-send Confirmation" @click.prevent="resend(props.row.hashid)" :disabled="!props.row.resendable">

                                <span class="icon text-white-50">
                                  <i class="fas fa-paper-plane"></i>
                                </span>
                                <span class="text">Re-send</span>
                            </button>
                        </span>
                        <span v-else-if="props.row.rejected_at" >
                            <button v-if="event.ended" class="btn btn-warning btn-circle btn-sm" >
                                <i class="fas fa-times"></i>
                            </button>
                            <button v-else class="btn btn-warning btn-circle btn-sm" @click.prevent="accept(props.row.hashid)">
                                <i class="fas fa-times"></i>
                            </button>
                            <span class="text-warning">Not Interested</span>
                        </span>
                        <span v-else>
                            <button v-if="event.ended" class="btn btn-outline-secondary btn-circle btn-sm">

                            </button>
                            <button v-else class="btn btn-outline-secondary btn-circle btn-sm" @click.prevent="accept(props.row.hashid)">

                            </button>
                        </span>
                    </template>
                    <template slot="attended" slot-scope="props">
                        <span v-if="props.row.attended_at" >
                            <button class="btn btn-success btn-circle btn-sm" @click.prevent="unattend(props.row.hashid)">
                                <i class="fas fa-check"></i>
                            </button>
                        </span>
                        <span v-else>
                            <button class="btn btn-outline-secondary btn-circle btn-sm" @click.prevent="attend(props.row.hashid)">

                            </button>
                        </span>
                    </template>
                </vue-bootstrap4-table>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group mb-0 clearfix">

                    <button v-if="editable == '1'" class="btn btn-success btn-icon-split" @click="sendReminder" :disabled="event.ended || !event.remindable">

                        <span class="icon text-white-50">
                          <i class="fas fa-paper-plane "></i>
                        </span>
                        <span class="text">Send Reminder Email</span>
                    </button>
                    <button v-if="editable == '1'" class="btn btn-primary btn-icon-split" @click="duplicateEvent">
                        <span class="icon text-white-50">
                          <i class="fas fa-clone "></i>
                        </span>
                        <span class="text">Duplicate Event</span>
                    </button>
                    <button v-if="editable == '1' && event.guests.length <= 20" class="btn btn-danger btn-icon-split" @click="resetEvent" :disabled="event.ended">
                        <span class="icon text-white-50">
                          <i class="fas fa-user-times"></i>
                        </span>
                        <span class="text">Reset</span>
                    </button>
                    <button v-if="editable == '1' && event.guests.length > 20" class="btn btn-danger btn-icon-split" disabled="disabled">
                        <span class="icon text-white-50">
                          <i class="fas fa-user-times"></i>
                        </span>
                        <span class="text">Can't reset event for more than 20 recipients</span>
                    </button>
                </div><!--form-group-->
            </div><!--col-->
        </div><!--row-->
    </div>
</template>

<script>

    import VueBootstrap4Table from 'vue-bootstrap4-table'
    var moment = require('moment-timezone');
    //moment().format()


    export default {
        name: 'EventShow',
        data() {
            return {
                event: {
                    contact_list: {
                        name: null
                    },
                    guests: []
                },
                dt: {
                    classes: {
                        table: {
                            "table-striped": true,
                        }
                    },
                    columns: [
                        {
                            label: "Name",
                            name: "name",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Company",
                            name: "company",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Email",
                            name: "email",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Job Title",
                            name: "job_title",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Tel",
                            name: "tel",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            slot_name: "tel"
                        },
                        {
                            label: "Referred By",
                            name: "referrer",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            slot_name: "referrer"
                        },
                        {
                            label: "Response",
                            name: "accepted_at",
                            sort: true,
                            row_text_alignment:  "text-center",
                            column_text_alignment:  "text-center",
                            slot_name: "accepted"
                        },
                        {
                            label: "Attended",
                            name: "attended_at",
                            sort: true,
                            row_text_alignment:  "text-center",
                            column_text_alignment:  "text-center",
                            slot_name: "attended"
                        },
                    ],
                    config: {
                        card_mode: false,
                        show_refresh_button: false,
                        show_reset_button: false,
                        per_page: 50,
                        per_page_options:  [50,  100,  200,  500],
                    },
                    actions: [
                        {
                            btn_text: "Download Excel",
                            event_name: "on-download",
                            class: "btn btn-outline-primary",
                            event_payload: {
                                //msg: "my custom msg"
                            }
                        }
                    ],
                },
            }
        },
        computed: {
            attended_count: function () {
                var obj = _.countBy(this.event.guests, function (rec) {
                    return rec.attended_at != null;
                });
                return obj.true?obj.true:0
            }
        },
        components: {
            VueBootstrap4Table
        },
        props: {
            hashid: {
                type: String,
                // Object or array defaults must be returned from
                // a factory function
            },
            editable: Boolean,
        },
        methods: {

            moment(date) {
                return moment(date)
            },
            hk_moment(date) {
                if (date)
                    return moment.tz(date, 'YYYY-MM-DD hh:mm', 'Asia/Hong_Kong')
                else
                    return moment().tz('Asia/Hong_Kong')
            },
            download() {
                axios({
                    url: '/event/'+ this.hashid +'/download',
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'download.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                });

            },
            attend(hashid) {
                var guest = _.find(this.event.guests, ['hashid', hashid])
                axios.patch('/api/guest/'+hashid+'/attend').then((response) => {
                    guest.attended_at = response.data.guest.attended_at
                }).catch((error) => {

                });
            },
            unattend(hashid) {
                var guest = _.find(this.event.guests, ['hashid', hashid])
                axios.patch('/api/guest/'+hashid+'/unattend').then((response) => {
                    guest.attended_at = null
                }).catch((error) => {

                });
            },
            accept(hashid) {
                Swal.fire({
                    title: 'Are you sure to change the response to ACCEPT?',
                    text: 'Confirmation email will be sent to the guest immediately after marking accepted',
                    icon: 'question',
                    confirmButtonText: 'Yes, Mark Accepted',
                    cancelButtonText: 'No, Go Back',
                    showCancelButton: true,
                    focusCancel: true,
                }).then((result) => {
                    if (result.value) {
                        var guest = _.find(this.event.guests, ['hashid', hashid])
                        axios.patch('/api/guest/'+hashid+'/accept').then((response) => {
                            guest.accepted_at = response.data.guest.accepted_at
                            guest.confirmation_sent_at = moment().format('YYYY-MM-DD HH:mm')
                            guest.resendable = false

                        }).catch((error) => {

                        });
                    }
                })


            },
            unaccept(hashid) {
                Swal.fire({
                    title: 'Are you sure to revert the ACCEPT response?',
                    text: '',
                    icon: 'question',
                    confirmButtonText: 'Yes, Please Revert',
                    cancelButtonText: 'No, Go Back',
                    showCancelButton: true,
                    focusCancel: true,
                }).then((result) => {
                    if (result.value) {
                        var guest = _.find(this.event.guests, ['hashid', hashid])
                        axios.patch('/api/guest/'+hashid+'/unaccept').then((response) => {
                            guest.accepted_at = null
                            guest.confirmation_sent_at = null
                            guest.resendable = false

                        }).catch((error) => {

                        });
                    }
                })


            },
            resend(hashid) {
                Swal.fire({
                    title: 'Are you sure to re-send confirmation email?',
                    text: 'Confirmation email will be sent to the guest immediately',
                    icon: 'question',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    focusCancel: true,
                }).then((result) => {
                    if (result.value) {
                        var guest = _.find(this.event.guests, ['hashid', hashid])

                        axios.patch('/api/guest/'+hashid+'/resend').then((response) => {
                            guest.confirmation_sent_at = response.data.guest.confirmation_sent_at
                            guest.resendable = false

                        }).catch((error) => {
                            Swal.fire({
                                title: 'Error',
                                text: 'Please wait for an hour to re-send reconfirmation email again.',
                                icon: 'error',
                                confirmButtonText: 'Dismiss'
                            }).then((result) => {
                            });
                        });
                    }
                })


            },
            sendReminder() {
                location.href='/event/'+ this.event.hashid +'/reminder'
            },
            duplicateEvent() {
                Swal.fire({
                    title: 'Are you sure to duplicate this event?',
                    text: 'A new event will be created with the same data, except contact list',
                    icon: 'question',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    focusCancel: true,
                }).then((result) => {
                    if (result.value) {
                        axios.post('/api/event/'+this.event.hashid+'/clone').then((response) => {
                            location.href='/event/'+ response.data.event.hashid + '/edit'
                        }).catch((error) => {
                            Swal.fire({
                                title: 'Error',
                                text: 'Unable to perform this action',
                                icon: 'error',
                                confirmButtonText: 'Dismiss'
                            }).then((result) => {
                            });
                        });
                    }
                })

            },
            resetEvent() {
                Swal.fire({
                    title: 'Are you sure to reset this event?',
                    text: 'All recipients will be cleared, and their invitation will be invalidated.  Then you can send invitation to other contact list and start inviting',
                    icon: 'question',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    focusCancel: true,
                }).then((result) => {
                    if (result.value) {
                        axios.post('/api/event/'+this.event.hashid+'/reset').then((response) => {
                            location.href='/event/'+ response.data.event.hashid + '/edit'
                        }).catch((error) => {
                            Swal.fire({
                                title: 'Error',
                                text: 'Unable to perform this action',
                                icon: 'error',
                                confirmButtonText: 'Dismiss'
                            }).then((result) => {
                            });
                        });
                    }
                })
            },
        },
        mounted() {
            axios.get('/api/event/'+this.hashid).then((response) => {
                this.event = response.data.event
            }).catch((error) => {
                Swal.fire({
                    title: 'Error',
                    text: 'Unable to retrieve record',
                    icon: 'error',
                    confirmButtonText: 'Dismiss'
                }).then((result) => {
                    location.href='/event'
                });
            });
        }
    }
</script>

<style scoped>

</style>
